<template>
    <div class="c-home__header">
        <div class="grid-container">
            <div class="grid-x grid-margin-x">
                <div class="small-12 cell">
                    <PartialsBreadcrumbs :page_title="home?.title?.rendered ? home.title.rendered : null" />
                </div>
            </div>
        </div>

        <div class="grid-container">
            <div class="grid-x grid-margin-x">
                <div class="small-12 medium-7 cell">
                    <HomeSlider :home="home" />
                </div>

                <div class="small-12 medium-5 cell">
                    <div class="c-home__meta">
                        <div class="c-home__print-title-wrapper">
                            <h1 v-if="home?.title?.rendered" class="c-home__title" v-html="home.title.rendered"></h1>

                            <HomePrice :home="home" :show_old_price="true" />
                        </div>

                        <div v-if="home?.park_features" class="c-home__features-wrapper is-park-features">
                            <div class="c-home__features-title">Why own at this park?</div>

                            <ul class="c-home__features">
                                <li v-for="(feature, index) in home?.park_features" :key="index">
                                    <i></i>

                                    <span v-html="feature.name"></span>
                                </li>
                            </ul>
                        </div>

                        <div v-if="home?.usps" class="c-home__features-wrapper is-home-usps">
                            <div class="c-home__features-title">Holiday home features</div>

                            <ul class="c-home__features">
                                <li v-for="(usp, index) in home?.usps" :key="index">
                                    <i></i>

                                    <span v-html="usp"></span>
                                </li>
                            </ul>
                        </div>

                        <ul class="c-home__buttons">
                            <li class="c-home__button">
                                <GlobalButton title="Enquire" @click="formOpen = true" />
                            </li>

                            <li class="c-home__button" :class="{ 'is-dual': home?.video_link && home?.tour_link }">
                                <NuxtLink v-if="home?.video_link" to="#home-video-tour" class="c-button c-button--beta">
                                    Take the video tour
                                </NuxtLink>

                                <NuxtLink
                                    v-if="home?.tour_link"
                                    to="#home-virtual-tour"
                                    class="c-button c-button--beta">
                                    360º Tour
                                </NuxtLink>
                            </li>

                            <li class="c-home__button">
                                <GlobalButton title="Share to print" :type="`gamma`" @click="print" />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <transition name="slide-out">
        <HomeEnquiryForm v-if="formOpen" @formClose="formOpen = false" :formOpen="formOpen" />
    </transition>
</template>

<script setup>
    defineProps({
        home: {
            type: Object,
            required: true,
        },
    });

    const formOpen = ref(false);

    const print = () => {
        const swiperEl = document.querySelector('.js-home-slider swiper-container');

        // Reset to first slide so images appear in print view
        if (swiperEl && swiperEl.swiper) {
            swiperEl.swiper.slideTo(0, 0);
        }

        // Slightly delay print dialog opening to allow for swiper to reset
        setTimeout(() => {
            window.print();
        }, 100);
    };
</script>

<style>
    .slide-out-enter-active,
    .slide-out-leave-active {
        transition:
            transform 0.4s ease,
            opacity 0.4s ease;
    }

    .slide-out-enter-from,
    .slide-out-leave-to {
        transform: translateX(100%);
        opacity: 0;
    }

    .slide-out-enter-to,
    .slide-out-leave-from {
        transform: translateX(0);
        opacity: 1;
    }
</style>
